import React from 'react';
import { scroller } from 'react-scroll';

import ContentDivider from '../ContentDivider';

import './styles.css';

const ContentIndex = ({ content }) => {
    if (!content) return <></>;
    if (content.index.length < 2) return <></>;

    const scrollToSection = (sectionId) => {
        scroller.scrollTo(sectionId, {
            duration: 500,
            offset: -100,
            smooth: 'easeInOutQuart',
        });
    };

    return (
        <>
            <aside className='ncs-content-index'>
                <h2>Índice:</h2>
                <ol>
                    {content.index.map((section) => (
                        <li
                            key={section.slug}
                            onClick={() => scrollToSection(section.slug)}
                        >
                            {section.title}
                        </li>
                    ))}
                </ol>
            </aside>
            <ContentDivider position='middle' />
        </>
    );
};

export default ContentIndex;
